/* CLADDAL theme.js — small, dependency-free. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = window.Claddal || {};
  const routes = root.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', predictive_search_url: '/search/suggest' };

  /* Toast ----------------------------------------------------------------- */
  let toastEl, toastT;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  /* Header scroll state ---------------------------------------------------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Drawers / modals ------------------------------------------------------- */
  let lastFocus = null;
  const openLayer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const f = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 60);
  };
  const closeLayer = (el) => {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.dataset.open)); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeLayer(closer.closest('.drawer, .search-modal')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .search-modal.is-open').forEach(closeLayer);
  });

  /* Predictive search ------------------------------------------------------ */
  const searchInput = $('#SearchModal input[name="q"]');
  const results = $('#PredictiveResults');
  if (searchInput && results) {
    let t, ctrl;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor&section_id=predictive-search`;
          const r = await fetch(url, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { /* aborted */ }
      }, 180);
    });
  }

  /* Cart ------------------------------------------------------------------- */
  const cartDrawer = $('#CartDrawer');
  const updateCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });

  const refreshCartDrawer = async (open = false) => {
    try {
      const r = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const cur = $('#CartDrawerInner');
      if (fresh && cur) cur.replaceWith(fresh);
      const count = doc.querySelector('[data-drawer-count]');
      if (count) updateCount(parseInt(count.dataset.drawerCount, 10) || 0);
      if (open && cartDrawer) openLayer(cartDrawer);
    } catch (e) { window.location.href = routes.cart_url; }
  };

  const addToCart = async (id, qty = 1, btn) => {
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not add to bag.'); return false; }
      if (cartDrawer && !document.body.classList.contains('template-cart')) await refreshCartDrawer(true);
      else window.location.href = routes.cart_url;
      return true;
    } catch (e) { toast('Something went wrong. Please try again.'); return false; }
    finally { btn && btn.classList.remove('is-loading'); }
  };
  root.addToCart = addToCart;

  const changeLine = async (key, quantity) => {
    const r = await fetch(`${routes.cart_change_url}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!r.ok) { const d = await r.json().catch(() => ({})); toast(d.description || 'Could not update bag.'); }
    if (document.body.classList.contains('template-cart')) window.location.reload();
    else await refreshCartDrawer(false);
  };

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault();
      const line = q.closest('[data-line-key]');
      const input = line.querySelector('input[data-qty]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(q.dataset.qtyChange, 10));
      changeLine(line.dataset.lineKey, next);
      return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('[data-line-key]').dataset.lineKey, 0); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); e.stopPropagation(); addToCart(qa.dataset.quickAdd, 1, qa); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[data-qty]');
    if (input) changeLine(input.closest('[data-line-key]').dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* Product form ----------------------------------------------------------- */
  $$('[data-product-form]').forEach((form) => {
    const section = form.closest('[data-product-section]');
    const dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const idInput = $('input[name="id"]', form);
    const addBtn = $('[data-add-btn]', form);
    const addLabel = $('[data-add-label]', form);
    const err = $('[data-option-error]', form);
    const priceEls = $$('[data-price]', section);
    const stickyBtn = $('[data-sticky-add]', section);
    const stickySize = $('[data-sticky-size]', section);
    const requireChoice = form.dataset.requireChoice === 'true';
    let chosen = !requireChoice;

    const selected = () => product.options.map((_, i) => {
      const c = $(`input[data-option-index="${i}"]:checked`, form);
      return c ? c.value : null;
    });

    const findVariant = (vals) => product.variants.find((v) => v.options.every((o, i) => o === vals[i]));

    const markAvailability = () => {
      const vals = selected();
      product.options.forEach((_, i) => {
        $$(`input[data-option-index="${i}"]`, form).forEach((inp) => {
          const ok = product.variants.some((x) => x.available && x.options.every((o, j) =>
            j === i ? o === inp.value : (vals[j] === null || o === vals[j])));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const render = () => {
      const vals = selected();
      const v = vals.every((x) => x !== null) ? findVariant(vals) : null;
      $$('[data-option-value]', form).forEach((el) => { const i = el.dataset.optionValue; el.textContent = vals[i] ? vals[i] : ''; });
      if (!v) { addBtn.disabled = false; addLabel.textContent = addBtn.dataset.labelAdd; return; }
      idInput.value = v.id;
      priceEls.forEach((el) => { el.innerHTML = root.formatMoney ? root.formatMoney(v.price, v.compare_at_price) : el.innerHTML; });
      if (!v.available) { addBtn.disabled = true; addLabel.textContent = addBtn.dataset.labelSoldout; }
      else { addBtn.disabled = false; addLabel.textContent = addBtn.dataset.labelAdd; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout; }
      if (stickySize) stickySize.textContent = chosen ? vals.join(' / ') : '';
      if (chosen && product.variants.length > 1) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      markAvailability();
    };

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[data-option-index]')) { chosen = true; err && err.classList.remove('is-visible'); render(); }
    });

    const submit = async (btn) => {
      if (!chosen) {
        err && err.classList.add('is-visible');
        const first = $('.option', form); first && first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      await addToCart(idInput.value, 1, btn);
    };
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(addBtn); });
    stickyBtn && stickyBtn.addEventListener('click', () => submit(stickyBtn));

    /* sticky bar visibility */
    const sticky = $('.sticky-atc', section);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const past = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && past);
      }).observe(addBtn);
    }
    render();
  });

  /* Gallery dots ------------------------------------------------------------ */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__track', g);
    const dots = $$('.gallery__dots button', g);
    const count = $('[data-gallery-index]', g);
    if (!track) return;
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
        if (count) count.textContent = i + 1;
      });
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })));
  });

  /* Size guide dialog ------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-dialog-open]');
    if (b) { const d = document.getElementById(b.dataset.dialogOpen); d && d.showModal && d.showModal(); }
    const c = e.target.closest('[data-dialog-close]');
    if (c) c.closest('dialog').close();
  });
  $$('dialog.modal').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));

  /* Facets: auto-submit ----------------------------------------------------- */
  $$('[data-facets-form]').forEach((form) => {
    let t;
    form.addEventListener('change', (e) => {
      if (window.matchMedia('(min-width: 990px)').matches || e.target.name === 'sort_by') {
        clearTimeout(t); t = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 250);
      }
    });
    form.addEventListener('submit', () => {
      $$('input', form).forEach((i) => { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
    });
  });
  const sort = $('[data-sort-select]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
